// this is an autogenerated file from App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_EmbeddableCoreMessageListener_PaymentsPostPayment(
  $patient_id: numeric!
  $patient_uuid: uuid!
  $location_id: numeric!
  $receivable_id: numeric!
  $include_receivable: Boolean!
  $payment_account_id: numeric!
  $include_patient_due_amount: Boolean!
) {
  patient_due_amount: financial_patient_due_amount(
    args: { _patient_id: $patient_uuid }
    where: { payment_account_id: { _eq: $payment_account_id } }
  ) @include(if: $include_patient_due_amount) {
    due_now
  }
  insureds: vaxiom_insured(
    where: {
      deleted: { _eq: false }
      patient_id: { _eq: $patient_id }
      insurance_subscription: {
        deleted: { _eq: false }
        active: { _eq: true }
        insurance_plan: {
          insurance_company: {
            insurance_payment_accounts: { id: { _is_null: false } }
          }
        }
      }
    }
  ) {
    id
    insurance_subscription {
      id
      person {
        _id
        id
        first_name
        greeting
        last_name
      }
      insurance_plan {
        id
        number
        insurance_company {
          id
          carrier_name
          insurance_payment_accounts {
            id
          }
        }
      }
    }
  }
  patient: vaxiom_patients_by_pk(id: $patient_id) {
    id
    _id
    person {
      id
      _id
      first_name
      greeting
      last_name
      # if none, new one will be created
      person_payment_account {
        id
        payer_person {
          _id
          id
          first_name
          greeting
          last_name
        }
      }
      to_person_relationships(where: { role: { _eq: "RESPONSIBLE" } }) {
        id
        from_person_record {
          _id
          id
          first_name
          greeting
          last_name
          # if none, new one will be created
          person_payment_account {
            id
          }
        }
      }
    }
    # TODO: move this into financial schema once it is stable/approved
    #
    # payments accounts from ledger history (e.g. for externals)
    # src/main/java/com/axpm/financial/core/internal/ledger/service/impl/PatientLedgerFinancialServiceImpl.java
    # Collection<PaymentAccountDTO> paymentAccounts = paymentAccountsService.findPaymentAccounts
    receivables(
      distinct_on: payment_account_id
      where: {
        payment_account: { account_type: { _eq: PersonPaymentAccount } }
      }
    ) {
      id
      payment_account {
        id
        person_payment_account {
          id
          payer_person {
            _id
            id
            first_name
            greeting
            last_name
          }
        }
      }
    }
    payments(
      where: { account: { account_type: { _eq: PersonPaymentAccount } } }
    ) {
      id
      account {
        id
        person_payment_account {
          id
          payer_person {
            _id
            id
            first_name
            greeting
            last_name
          }
        }
      }
    }
  }
  payment_methods: vaxiom_payment_types(
    where: {
      deleted: { _eq: false }
      payment_types_locations: { organization_id: { _eq: $location_id } }
    }
    order_by: { name: asc }
  ) {
    id
    name
    type
  }
  receivable: vaxiom_receivables_by_pk(id: $receivable_id)
    @include(if: $include_receivable) {
    id
    balance_amount
    payment_account_id
    human_readable_id
  }
}

`